import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AlertService, MenuService, PiezasTipoService, UsuariosService } from '@app/_services';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-piezasTipo',
  templateUrl: './piezasTipo.component.html'
})
export class PiezasTipoComponent implements OnInit {

  form: FormGroup;
  dataPiezasTipo: any;
  mySelection: number[] = [];
  navigationSubscription;
  isDeleting = false;
  public user: any;

  modalReference: NgbModalRef;

  constructor(private piezasTipoService: PiezasTipoService,
    private alertService: AlertService,
    private menuService: MenuService,
    public router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private userService: UsuariosService,
    private translateService: TranslateService,
    private modalService: NgbModal) {

    this.user = this.userService.userValue;

    this.menuService.titulo = this.translateService.instant('piezastipo').toUpperCase();

    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        if (this.router.url == '/piezastipo') {
          this.cargarDatos();
        }
      }
    });

  }

  cargarDatos() {
    this.piezasTipoService.getAll().pipe(first()).subscribe((result) => {
      this.dataPiezasTipo = result;
    });

  }

  ngOnInit(): void {
    this.cargarDatos();
  }

  cellClick(e) {
    if (e.columnIndex > 0) {
      this.router.navigate(['piezastipo/editar/', this.mySelection[0]]);
    }
  }

  onClickEditar() {
    if (this.mySelection[0] > 0) {
      this.router.navigate(['piezastipo/editar/', this.mySelection[0]]);
    }
  }

  onClickNuevo() {
    this.router.navigate(['piezastipo/crear']);
  }

  onClickEliminar(content) {
    if (this.mySelection[0] > 0) {
      this.modalReference = this.modalService.open(content, { backdrop: 'static', size: 'lg', keyboard: false, centered: true });
    }
  }

  eliminarRegistro() {

    this.mySelection.forEach(element => {
      if (element > 0) {
        this.isDeleting = true;
        this.form = this.formBuilder.group({
          id: element
        });
        this.piezasTipoService.delete(this.form.value.id).pipe(first()).subscribe({
          next: () => {
            this.dataPiezasTipo = this.dataPiezasTipo.filter(x => x.id !== element);
            this.isDeleting = false;
            this.alertService.success(this.translateService.instant('eliminadocorrectamente'), { keepAfterRouteChange: true });
            this.router.navigate(['../piezastipo'], { relativeTo: this.route });
          },
          error: error => {
            this.isDeleting = false;
            this.alertService.error(error);
          }
        });
      }
    });

    this.modalReference.close();
    this.mySelection = [];

  }

}
